/* 周瑜傳共用的小工具：劉繇、曹營的將領（不是可選武將），糧車、高樓、柴堆、營旗的畫法，敵人的「盯住目標」與「走到某處」 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';

// 史書上有名、但不是可選武將的人（招式用通用的）
const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, skills) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), skills);
const LIUYAO_C = { armor: '#5d6a78', cloth: '#3f4a56', cape: '#4a5664', plume: '#9aa7b5' };
export const ZY_PEOPLE = {
  fanneng: P('zy_fanneng', '樊能', '劉繇部將', 'neutral', '戰士', 'spear', { beard: 'mustache', bulk: 1.1, c: LIUYAO_C }, [
    ['挺槍', 'crescent', '造成 {90/90/90/90} 傷害。'], ['突刺', 'charge', '衝撞造成 {70/70/70/70} 傷害。'], ['亂刺', 'spin', '每圈 {40/40/40/40} 傷害。'], ['死守', 'slam', '{120/120/120} 傷害。']]),
  yumi: P('zy_yumi', '于麋', '劉繇部將', 'neutral', '戰士', 'sword', { beard: 'goatee', c: LIUYAO_C }, [
    ['揮刀', 'crescent', '造成 {80/80/80/80} 傷害。'], ['搶攻', 'charge', '衝撞造成 {60/60/60/60} 傷害。'], ['迴刀', 'spin', '每圈 {40/40/40/40} 傷害。'], ['斬', 'slam', '{110/110/110} 傷害。']]),
  zhangying: P('zy_zhangying', '張英', '劉繇部將', 'neutral', '戰士', 'halberd', { eye: 'fierce', beard: 'bushy', bulk: 1.15, size: 1.1, c: LIUYAO_C }, [
    ['橫戟', 'crescent', '造成 {110/110/110/110} 傷害。'], ['衝陣', 'charge', '衝撞造成 {80/80/80/80} 傷害。'], ['圍殺', 'spin', '每圈 {50/50/50/50} 傷害。'], ['破陣', 'slam', '{150/150/150} 傷害。']]),
};

// 敵兵盯住某個目標（不讓 creepAI 換成身邊最近的人）；t 沒了就放回去自己挑
export function chase(u, t) {
  if (!u.alive) return;
  if (t && t.alive) { u.target = t.vis[u.team] ? t : null; u.think = 0.5; u.home = [t.x, t.y]; } else { u.think = Math.min(u.think, 0.3); } // 還看不到：先往那裡走
}
// 走到某處、不理會路上的人（敗走、行軍）
export function walkTo(u, x, y) { if (!u.alive) return; u.target = null; u.aggro = null; u.think = 99; u.home = [x, y]; }

// ---- 畫法 ----
export function wagon(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 54, 12, 80, 0.3);
  poly(ctx, [[-48, -12], [48, -12], [48, -30], [-48, -30]], '#7a5634', 2);
  for (const x of [-30, 30]) { ctx.beginPath(); ctx.arc(x, -6, 13, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-42, -30], [-4, -30], [-6, -58], [-40, -58]], '#c9b07a', 1.6); // 糧袋
  poly(ctx, [[2, -30], [42, -30], [38, -52], [6, -52]], '#b89a62', 1.6);
  ctx.fillStyle = '#c0302a'; ctx.fillRect(40, -86, 3, 56); ctx.fillRect(43, -86, 18, 12); // 小旗
  ctx.restore();
}
// 高樓：曹仁圍夷陵時立的箭樓（燒掉後只剩焦黑的架子）
export function tower(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 6, 60, 16, 110, 0.35);
  const c = f.burnt ? '#2e2620' : '#7a5a3a';
  for (const x of [-34, 34]) poly(ctx, [[x - 6, 0], [x + 6, 0], [x * 0.6 + 5, -150], [x * 0.6 - 5, -150]], c, 1.8);
  poly(ctx, [[-36, -40], [36, -40], [32, -48], [-32, -48]], c, 1.4);
  poly(ctx, [[-40, -150], [40, -150], [40, -176], [-40, -176]], f.burnt ? '#3a302a' : '#94704a', 2);
  if (!f.burnt) { poly(ctx, [[-46, -176], [46, -176], [0, -204]], '#5a4630', 1.8); ctx.fillStyle = '#3b5a99'; ctx.fillRect(-2, -240, 3, 40); ctx.fillRect(1, -240, 20, 13); }
  if (f.fire > 0) for (let i = 0; i < 3; i++) { const h = 40 + 16 * Math.sin(T * 9 + i); ctx.fillStyle = i % 2 ? '#f0a030' : '#e8541c'; ctx.beginPath(); ctx.moveTo(-30 + i * 30 - 16, -150); ctx.quadraticCurveTo(-30 + i * 30, -150 - h - 20, -30 + i * 30 + 16, -150); ctx.fill(); }
  ctx.restore();
}
// 柴堆：砍樹橫在險道上
export function chai(ctx, f, T) {
  const { caps } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 70, 14, 60, 0.3);
  for (let i = 0; i < 5; i++) { const y = -6 - i * 9, w = 64 - i * 8; caps(ctx, [[[-w, y + (i % 2) * 4], [w, y - (i % 2) * 4], 7 - i * 0.6, i % 2 ? '#6a4a2a' : '#5a3d22']]); }
  caps(ctx, [[[-40, -10], [-58, -52], 3, '#4a6a32'], [[30, -14], [50, -50], 3, '#4a6a32']]);
  ctx.restore();
}
// 營旗：營落的大旗，旗下一條士氣（m 是任務，f.st 是那一處營落）
export function banner(ctx, f, T) {
  const s = f.st;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.caps(ctx, [[[0, 0], [0, -150], 4, '#4a3424']]);
  const wav = Math.sin(T * 3 + f.x) * 4, col = s && s.broken ? '#5a5048' : '#c0302a';
  ctx.fillStyle = col; ctx.beginPath(); ctx.moveTo(2, -150); ctx.lineTo(56, -146 + wav); ctx.lineTo(54, -106 + wav); ctx.lineTo(2, -110); ctx.closePath(); ctx.fill();
  ctx.fillStyle = '#f2e6c8'; ctx.font = '900 22px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(s && s.broken ? '亂' : '周', 28, -128 + wav / 2);
  if (s) {
    const k = Math.max(0, Math.min(1, s.mo / 100));
    ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fillRect(-40, -176, 80, 9);
    ctx.fillStyle = k > 0.5 ? '#7ac060' : k > 0.25 ? '#e0b040' : '#d04030'; ctx.fillRect(-39, -175, 78 * k, 7);
    ctx.font = '700 14px "Noto Serif TC", serif'; ctx.fillStyle = '#f2e6c8'; ctx.strokeStyle = 'rgba(0,0,0,.7)'; ctx.lineWidth = 3;
    ctx.strokeText(s.name, 0, -190); ctx.fillText(s.name, 0, -190);
  }
  ctx.restore();
}
